import React from "react";
import ApplicationsPage from "./ApplicationsPage";

const ApprovedApplications = () => <ApplicationsPage status="approved" />;

export default ApprovedApplications;
